import ModelEntity from "../../../model-entity";
import {EntityType} from "../../../../gd/const/item";

export default class CrmAccountSession extends ModelEntity {

    public id       : ID
    public name     : string

    constructor(data:any) {
        super(data['id'], EntityType.CRM_ACCOUNT);

        this.id =                   data['id']
        this.name =                 data['name']
    }
}
